export default "__VITE_ASSET__35ab2ae9__"